import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataBusinessUserStatusState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataBusinessUserStatusReducer.businessUserStatusFeatureKey]
);

export const getStaticDataBusinessUserStatusFailure = createSelector(
  getStaticDataBusinessUserStatusState,
  staticDataCountriesReducer.fromStaticDataBusinessUserStatusReducer.getBusinessUserStatusFailure
);

export const getStaticDataBusinessUserStatusResponse = createSelector(
  getStaticDataBusinessUserStatusState,
  staticDataCountriesReducer.fromStaticDataBusinessUserStatusReducer.getBusinessUserStatusResponse
);

export const getStaticDataBusinessUserStatusIsLoaded = createSelector(
  getStaticDataBusinessUserStatusState,
  staticDataCountriesReducer.fromStaticDataBusinessUserStatusReducer.getBusinessUserStatusIsLoaded
);
